import React, { Component } from 'react';
import View360 from './elements/View360';
import styled, { keyframes } from 'styled-components';

import Compass from './elements/Compass';
import Button from 'src/components/Button';

import pannellum from 'src/data/pannellum';

class Panorama extends Component {
  state = {
    isDraging: false,
    active: 2,
    dragAngle: 0,
  };

  handleUpdate = angle => {
    this.setState({ isDraging: true, dragAngle: angle });
  };

  handleClickLevel = index => {
    this.setState({ active: index, dragAngle: 0 });
  };

  render() {
    return (
      <Root>
        <InfoBar>
          <Compass angle={this.state.dragAngle} />
        </InfoBar>
        {pannellum.map((item, index) => (
          <View360Wrapper key={item.level} active={index === this.state.active}>
            <View360
              src={item.image}
              defaultAngle={0}
              onUpdate={this.handleUpdate}
            />
            <DragableMessage hide={this.state.isDraging}>
              Drag the image to pan the view
            </DragableMessage>
          </View360Wrapper>
        ))}
        <LevelSelectorWrapper>
          <InfoBar>Select a level</InfoBar>
          <ButtonWrapper>
            {pannellum.map((item, index) => (
              <Button
                key={item.level + 'button'}
                text={item.level}
                active={index === this.state.active}
                onClick={() => this.handleClickLevel(index)}
              />
            ))}
          </ButtonWrapper>
          <InfoBar />
        </LevelSelectorWrapper>
      </Root>
    );
  }
}

const animateShow = keyframes`
  0% {
    display: none;
  }
  1% {
    display: auto;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Root = styled.div`
  padding-bottom: 60px;
  overflow-x: hidden;
`;

const InfoBar = styled.div`
  width: 100%;
  height: 50px;
  background-color: #0b1a27;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'DINOT';
  font-weight: 500;
  font-size: 16px;
  color: #ff7802;
  letter-spacing: 0;
  text-transform: uppercase;
  display: ${props => (props.hide ? 'none' : 'auto')};
`;

const View360Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 600px;
  display: ${props => (props.active ? 'auto' : 'none')};
  animation: ${props =>
    props.active && `${animateShow} 0.4s ease-out forwards`};
`;

const DragableMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 120, 2, 0.36);
  border-radius: 25px;
  width: 345px;
  height: 50px;
  font-family: 'DINOT';
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.4s ease-out;
  opacity: ${props => (props.hide ? 0 : 1)};
  &::before {
    content: '';
    width: 8px;
    height: 13px;
    background-image: url(${require('src/assets/images/views/left-arrow.png')});
    margin-right: 15px;
  }
  &::after {
    content: '';
    width: 8px;
    height: 13px;
    background-image: url(${require('src/assets/images/views/right-arrow.png')});
    margin-left: 15px;
  }
`;

const LevelSelectorWrapper = styled.div``;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 750px;
  margin: 0 auto;
  padding: 20px 20px;
`;

export default Panorama;



// WEBPACK FOOTER //
// ./src/pages/Views/elements/Panorama/Panorama.js